import { Link } from 'react-router-dom';
import { FaWhatsapp, FaGraduationCap } from 'react-icons/fa';

const Footer = () => (
  <footer className="border-t border-gray-200 bg-white mt-8">
    <div className="max-w-5xl mx-auto px-4 py-8">

      {/* Top row */}
      <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-8 mb-8">

        {/* Brand */}
        <div className="max-w-xs">
          <div className="flex items-center gap-2 text-blue-700 font-bold text-lg mb-2">
            <FaGraduationCap className="text-2xl" />
            ChooseMyCollege
          </div>
          <p className="text-xs text-gray-500 leading-relaxed">
            Free TNEA college predictor and counselling guide for Tamil Nadu engineering admissions.
            Data covers 420+ Anna University affiliated colleges.
          </p>
          <a
            href="https://wa.me/918122552867?text=Hi%2C%20I%20need%20guidance%20for%20TNEA%20college%20selection."
            target="_blank" rel="noopener noreferrer"
            className="inline-flex items-center gap-2 mt-4 bg-green-500 hover:bg-green-600 text-white text-xs font-semibold px-4 py-2 rounded-lg transition-colors"
          >
            <FaWhatsapp className="text-base" />
            Chat with us on WhatsApp
          </a>
        </div>

        {/* Links */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-6 text-sm">
          <div>
            <h3 className="font-semibold text-gray-700 mb-3 text-xs uppercase tracking-wider">Tools</h3>
            <ul className="space-y-2">
              <li><Link to="/predictor" className="text-gray-500 hover:text-blue-600 transition-colors">College Predictor</Link></li>
              <li><Link to="/cutoffs" className="text-gray-500 hover:text-blue-600 transition-colors">Compare Cutoffs</Link></li>
              <li><Link to="/best-colleges" className="text-gray-500 hover:text-blue-600 transition-colors">Best Colleges</Link></li>
              <li><Link to="/colleges" className="text-gray-500 hover:text-blue-600 transition-colors">College Search</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold text-gray-700 mb-3 text-xs uppercase tracking-wider">Guides</h3>
            <ul className="space-y-2">
              <li><a href="/blog/how-to-calculate-tnea-cutoff.html" className="text-gray-500 hover:text-blue-600 transition-colors">Calculate Cutoff</a></li>
              <li><a href="/blog/tnea-counselling-process-step-by-step.html" className="text-gray-500 hover:text-blue-600 transition-colors">Counselling Process</a></li>
              <li><a href="/blog/best-engineering-colleges-tamil-nadu.html" className="text-gray-500 hover:text-blue-600 transition-colors">Best Colleges Guide</a></li>
              <li><a href="/blog/" className="text-gray-500 hover:text-blue-600 transition-colors">All Guides →</a></li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold text-gray-700 mb-3 text-xs uppercase tracking-wider">Company</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-500 hover:text-blue-600 transition-colors">About</Link></li>
              <li><Link to="/contact" className="text-gray-500 hover:text-blue-600 transition-colors">Contact</Link></li>
              <li><Link to="/privacy-policy" className="text-gray-500 hover:text-blue-600 transition-colors">Privacy Policy</Link></li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom row */}
      <div className="border-t border-gray-100 pt-5 flex flex-col md:flex-row md:items-center md:justify-between gap-2">
        <p className="text-xs text-gray-400">
          &copy; {new Date().getFullYear()} ChooseMyCollege — TNEA Admissions Guide, Tamil Nadu
        </p>
        <p className="text-xs text-gray-400">
          Data sourced from Anna University &amp; official TNEA records. Not affiliated with Anna University.
        </p>
      </div>

    </div>
  </footer>
);

export default Footer;
